const {REACT_APP_CLIENTZONE_URL} = process.env

export const WEBINAR_PAGES = [

// CZ
	{
		"url": "cz",
		"title": "Diamantová jistota - Webinár",
		"pixelEventPrefix": "CZ Webinar",
		"headline": "Získejte diamantový šperk za výhodnější cenu! Ve videu se dozvíte základní informace o tom, jaké další výhody Vám přináší členství v Diamantové jistotě. Zhlédněte jej a nezávazně se registrujte právě teď.",
		"watchWebinar": "ZHLÉDNOUT VIDEO",
		"src": "https://www.youtube.com/watch?v=nrloXVwdnhE",
		"action": {
			"text": "Nezávazná registrace",
			"url": REACT_APP_CLIENTZONE_URL + "/order-register",
			"queryParams": [
				"muid"
			],
			"redirectAfterWatch": true,
		},
		"numbers": [
			{
				"number": 1,
				"text": "Podívejte se na webinář",
			},
			{
				"number": 2,
				"text": "Nezávazně se registrujte",
				"className": "number-dark heart-beat",
				"url": REACT_APP_CLIENTZONE_URL + "/order-register",
			},
			{
				"number": 3,
				"text": "Čerpejte všechny výhody programu",
			}
		],
	},
	{
		"url": "investori-cz",
		"title": "Diamond certainty - Webinar pro investory",
		"pixelEventPrefix": "CZ Webinar investori",
		"headline": "Vytvořte si efektivní příjem s noblesní krásou. Využijte systém prověřený několika tisíci uživateli z několika zemí světa. Důležité a zásadní informace se dozvíte ve videu níže.",
		"watchWebinar": "ZHLÉDNOUT VIDEO",
		"src": "https://www.youtube.com/watch?v=nrloXVwdnhE",
		"action": {
			"text": "Zaregistrovat se nyní",
			"url": REACT_APP_CLIENTZONE_URL + "/order-register",
			"queryParams": [
				"muid"
			],
			"redirectAfterWatch": true,
		},
		"numbers": [
			{
				"number": 1,
				"text": "Podívejte se na webinář",
			},
			{
				"number": 2,
				"text": "Nezávazně se registrujte",
				"className": "number-dark heart-beat",
				"url": REACT_APP_CLIENTZONE_URL + "/order-register",
			},
			{
				"number": 3,
				"text": "Ozveme se Vám a pomůžeme Vám začít vydělávat",
			}
		],
	},
	{
		"url": "cz-lp",
		"title": "Diamantová jistota - Webinár II",
		"pixelEventPrefix": "CZ WebinarLP",
		"headline": "Vytvořte si efektivní příjem s noblesní krásou. Využijte systém prověřený několika tisíci uživateli z několika zemí světa. Důležité a zásadní informace se dozvíte ve videu níže.",
		"watchWebinar": "ZHLÉDNOUT VIDEO",
		"src": "https://www.youtube.com/watch?v=nrloXVwdnhE",
		"action": {
			"text": "Zaregistrovat se nyní",
			"url": REACT_APP_CLIENTZONE_URL + "/order-register",
			"queryParams": [
				"muid"
			],
			"redirectAfterWatch": true,
		},
		"numbers": [
			{
				"number": 1,
				"text": "Podívejte se na webinář",
			},
			{
				"number": 2,
				"text": "Nezávazně se registrujte",
				"className": "number-dark heart-beat",
				"url": REACT_APP_CLIENTZONE_URL + "/order-register",
			},
			{
				"number": 3,
				"text": "Ozveme se Vám a pomůžeme Vám začít vydělávat",
			}
		],
	},

// PL
	{
		"url": "webinar-pl",
		"title": "Diamond Certainty - Webinar",
		"pixelEventPrefix": "PL Webinar",
		"headline": "Biznes online, dzięki któremu zarobisz w internecie, zyskasz nowy samochód oraz dochód pasywny!",
		"watchWebinar": "OBEJRZYJ WEBINAR",
		"src": "https://www.youtube.com/watch?v=lzTPYnV8qfg",
		"action": {
			"text": "Zarejestruj się bez zobowiązań",
			"url": REACT_APP_CLIENTZONE_URL + "/pl/order-register",
			"queryParams": [
				"muid"
			],
			"redirectAfterWatch": true,
		},
		"numbers": [
			{
				"number": 1,
				"text": "Obejrzyj webinar",
			},
			{
				"number": 2,
				"text": "Zarejestruj się bez zobowiązań",
				"className": "number-dark heart-beat",
				"url": REACT_APP_CLIENTZONE_URL + "/pl/order-register",
			},
			{
				"number": 3,
				"text": "Skontaktujemy się z Tobą i pomożemy Ci zacząć zarabiać",
			}
		],
	},
	{
		"url": "pl",
		"title": "Diamond Certainty - Webinar",
		"pixelEventPrefix": "PL Webinar",
		"headline": "Biznes online, dzięki któremu zarobisz w internecie, zyskasz nowy samochód oraz dochód pasywny!",
		"watchWebinar": "OBEJRZYJ WEBINAR",
		"src": "https://www.youtube.com/watch?v=lzTPYnV8qfg",
		"action": {
			"text": "Zarejestruj się bez zobowiązań",
			"url": REACT_APP_CLIENTZONE_URL + "/pl/order-register",
			"queryParams": [
				"muid"
			],
			"redirectAfterWatch": true,
		},
		"numbers": [
			{
				"number": 1,
				"text": "Obejrzyj webinar",
			},
			{
				"number": 2,
				"text": "Zarejestruj się bez zobowiązań",
				"className": "number-dark heart-beat",
				"url": REACT_APP_CLIENTZONE_URL + "/pl/order-register",
			},
			{
				"number": 3,
				"text": "Skontaktujemy się z Tobą i pomożemy Ci zacząć zarabiać",
			}
		],
	},
	{
		"url": "introduction-pl",
		"title": "Diamond Certainty - Wprowadzenie",
		"pixelEventPrefix": "PL 8 min video",
		"headline": "Biznes online, dzięki któremu zarobisz w internecie, zyskasz nowy samochód oraz dochód pasywny!",
		"watchWebinar": "OBEJRZYJ WEBINAR",
		"src": "https://www.youtube.com/watch?v=lzTPYnV8qfg",
		// "src": "https://www.youtube.com/watch?v=DXPcke7A4Cs",
		"action": {
			"text": "Zarejestruj się bez zobowiązań",
			"url": REACT_APP_CLIENTZONE_URL + "/pl/order-register",
			"queryParams": [
				"muid"
			],
			"redirectAfterWatch": true,
		},
		"numbers": [
			{
				"number": 1,
				"text": "Obejrzyj webinar",
			},
			{
				"number": 2,
				"text": "Zarejestruj się bez zobowiązań",
				"className": "number-dark heart-beat",
				"url": REACT_APP_CLIENTZONE_URL + "/pl/order-register",
			},
			{
				"number": 3,
				"text": "Skontaktujemy się z Tobą i pomożemy Ci zacząć zarabiać",
			}
		],
	},

// ENG
	{
		"url": "eng",
		"title": "Diamond certainty - Webinar",
		"pixelEventPrefix": "ENG Webinar",
		"headline": "Online business thanks to which you will make money on the internet, you will get a new car and passive income!",
		"watchWebinar": "WATCH THE WEBINAR",
		"src": "https://youtu.be/v5HuCB01USw",
		// "src": "https://www.youtube.com/watch?v=CSaR3jVZO58",
		"description": [
			"Diamond Certainty is a product that allows the purchasing of top quality and certified diamonds by virtually anyone, since the price of a diamond and diamond jewelry is gradually repaid in the form of monthly deposits.",
			"Diamond Certainty program allows diamond and diamond jewerly ownership for almost any person, and thanks to unique marketing, it will give many people the opportunity to participate in the turnover of our company and make very interesting money, absolutely without any risk.",
		],
		"action": {
			"text": "Register without obligation",
			"url": REACT_APP_CLIENTZONE_URL + "/en/order-register",
			"queryParams": [
				"muid"
			],
			"redirectAfterWatch": true,
		},
		"numbers": [
			{
				"number": 1,
				"text": "Watch the webinar",
			},
			{
				"number": 2,
				"text": "Register without obligation",
				"className": "number-dark heart-beat",
				"url": REACT_APP_CLIENTZONE_URL + "/en/order-register",
			},
			{
				"number": 3,
				"text": "We will contact you and help you to make money",
			}
		],
	},
	{
		"url": "webinar-eng",
		"title": "Diamond certainty - Webinar",
		"pixelEventPrefix": "ENG Webinar with LB",
		"headline": "Online business thanks to which you will make money on the internet, you will get a new car and passive income!",
		"watchWebinar": "WATCH THE WEBINAR",
		"src": "https://youtu.be/v5HuCB01USw",
		"action": {
			"text": "Register without obligation",
			"url": REACT_APP_CLIENTZONE_URL + "/en/order-register",
			"queryParams": [
				"muid"
			],
			"redirectAfterWatch": true,
		},
		"numbers": [
			{
				"number": 1,
				"text": "Watch the webinar",
			},
			{
				"number": 2,
				"text": "Register without obligation",
				"className": "number-dark heart-beat",
				"url": REACT_APP_CLIENTZONE_URL + "/en/order-register",
			},
			{
				"number": 3,
				"text": "We will contact you and help you to make money",
			}
		],
	},
	{
		"url": "introduction-eng",
		"title": "Diamond certainty - Introduction",
		"pixelEventPrefix": "ENG 8 min video",
		"headline": "Online business thanks to which you will make money on the internet, you will get a new car and passive income!",
		"watchWebinar": "WATCH THE WEBINAR",
		"src": "https://youtu.be/v5HuCB01USw",
		// "src": "https://www.youtube.com/watch?v=bGhkSsFP91E",
		"action": {
			"text": "Register without obligation",
			"url": REACT_APP_CLIENTZONE_URL + "/en/order-register",
			"queryParams": [
				"muid"
			],
			"redirectAfterWatch": true,
		},
		"numbers": [
			{
				"number": 1,
				"text": "Watch the webinar",
			},
			{
				"number": 2,
				"text": "Register without obligation",
				"className": "number-dark heart-beat",
				"url": REACT_APP_CLIENTZONE_URL + "/en/order-register",
			},
			{
				"number": 3,
				"text": "We will contact you and help you to make money",
			}
		],
	},

// RO
	{
		"url": "ro",
		"title": "Certitudinea diamantului - Webinar",
		"pixelEventPrefix": "RO Webinar",
		"headline": "Afaceri online datorită cărora veți câștiga bani pe internet, veți obține o mașină nouă și venituri pasive!",
		"watchWebinar": "VEZI WEBINARUL",
		"src": "https://youtu.be/v5HuCB01USw",
		// "src": "https://www.youtube.com/watch?v=_Crv_OEPexw",
		"action": {
			"text": "Înregistrați-vă fără obligație",
			"url": REACT_APP_CLIENTZONE_URL + "/en/order-register",
			"queryParams": [
				"muid"
			],
			"redirectAfterWatch": true,
		},
		"numbers": [
			{
				"number": 1,
				"text": "Urmăriți seminarul web",
			},
			{
				"number": 2,
				"text": "Înregistrați-vă fără obligație",
				"className": "number-dark heart-beat",
				"url": REACT_APP_CLIENTZONE_URL + "/en/order-register",
			},
			{
				"number": 3,
				"text": "Vă vom contacta și vă vom ajuta să câștigați bani",
			}
		],
	},

// RU
	{
		"url": "ru",
		"title": "Бриллиантовая уверенность - вебинар",
		"pixelEventPrefix": "RU Webinar",
		"headline": "Интернет-бизнес, благодаря которому вы будете зарабатывать в интернете, получите новую машину и пассивный доход!",
		"watchWebinar": "ПОСМОТРЕТЬ ВЕБИНАР",
		"src": "https://youtu.be/v5HuCB01USw",
		// "src": "https://www.youtube.com/watch?v=sfDuxNJtqmA",
		"action": {
			"text": "Зарегистрируйтесь без обязательств",
			"url": REACT_APP_CLIENTZONE_URL + "/ru/order-register",
			"queryParams": [
				"muid"
			],
			"redirectAfterWatch": true,
		},
		"numbers": [
			{
				"number": 1,
				"text": "Посмотреть вебинар",
			},
			{
				"number": 2,
				"text": "Зарегистрируйтесь без обязательств",
				"className": "number-dark heart-beat",
				"url": REACT_APP_CLIENTZONE_URL + "/ru/order-register",
			},
			{
				"number": 3,
				"text": "Мы свяжемся с вами и поможем заработать",
			}
		],
	},

// BG
	{
		"url": "bg",
		"title": "Диамантена сигурност - Уебинар",
		"pixelEventPrefix": "BG Webinar",
		"headline": "Онлайн бизнес, благодарение на който ще печелите пари в интернет, ще получите нова кола и пасивни доходи!",
		"watchWebinar": "ГЛЕДАЙТЕ УЕБИНАРА",
		"src": "https://youtu.be/AMku1SKmS78",
		"action": {
			"text": "Регистрирайте се без задължение",
			"url": REACT_APP_CLIENTZONE_URL + "/bg/order-register",
			"queryParams": [
				"muid"
			],
			"redirectAfterWatch": true,
		},
		"numbers": [
			{
				"number": 1,
				"text": "Гледайте уебинара",
			},
			{
				"number": 2,
				"text": "Регистрирайте се без задължение",
				"className": "number-dark heart-beat",
				"url": REACT_APP_CLIENTZONE_URL + "/bg/order-register",
			},
			{
				"number": 3,
				"text": "Ние ще се свържем с вас и ще ви помогнем да спечелите пари",
			}
		],
	},

// HI
	{
		"url": "hi",
		"title": "डायमंड निश्चितता - वेबिनार",
		"pixelEventPrefix": "HI Webinar",
		"headline": "ऑनलाइन नया व्यवसाय जहां आप इंटरनेट के माध्यम से पैसा कमा सकते हैं  कृपया वेबिनार की जाँच करें आपको मिल जायेगा",
		"watchWebinar": "कृपया वेबिनार की जाँच करें",
		"src": "https://youtu.be/v5HuCB01USw",
		// "src": "https://youtube.com/watch?v=NAUU2LbGfNc",
		"action": {
			"text": "कृपया वेबिनार की जाँच करें",
			"url": REACT_APP_CLIENTZONE_URL + "/hi/order-register",
			"queryParams": [
				"muid"
			],
			"redirectAfterWatch": true,
		},
		"numbers": [
			{
				"number": 1,
				"text": "वेबिनार देखें",
			},
			{
				"number": 2,
				"text": "दायित्व के बिना पंजीकरण करें",
				"className": "number-dark heart-beat",
				"url": REACT_APP_CLIENTZONE_URL + "/hi/order-register",
			},
			{
				"number": 3,
				"text": "हम आपसे संपर्क करेंगे और आपको पैसा बनाने में मदद करेंगे",
			}
		],
	},
]